import React from "react";
import "../App.css";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import Moment from "moment";
import "primeicons/primeicons.css";
import "primereact/resources/themes/nova-light/theme.css";
import "primereact/resources/primereact.css";
import "primeflex/primeflex.css";
import { Paginator } from "primereact/paginator";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Popovers from "react-bootstrap/Popover";
import logo from "../Asset/download.jpg";
import { getCrewPhoto } from "../Actions/CrewManagement";
import Modal from "react-bootstrap/Modal";

class MMPLCrewVisitorCard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      first: 0,
      modalIsOpen: false,
      Name: "",
    };
  }

  componentDidMount() {
    window.scrollTo(0, 0);
  }

  renderPopover(reading) {
    return (
      <Popovers id="history-tooltip">
        <Popovers.Content>
          <label style={{ padding: "0px 10px" }}>
            {reading?.toLowerCase() === "true"
              ? "Failed"
              : reading?.toLowerCase() === "false"
                ? "Passed"
                : "Refused"}
          </label>
        </Popovers.Content>
      </Popovers>
    );
  }

  render() {
    const { totalRecords, pageSize, GetCrewPhoto } = this.props;
    return (
      <div className="pb-4">
        <div className="row mt-3">
          <div className="col-lg-12">
            <div className="p-0">
              <div className="row">
                <div className="col-sm-12">
                  <Modal
                    size="md"
                    show={this.state.modalIsOpen}
                    onHide={() => this.setState({ modalIsOpen: false })}
                    aria-labelledby="example-modal-sizes-title-sm"
                    backdrop="static"
                    centered="true"
                    animation="true"
                  >
                    <Modal.Header closeButton>
                      <Modal.Title id="example-modal-sizes-title-sm">
                        {this.state.Name}
                      </Modal.Title>
                    </Modal.Header>

                    <Modal.Body>
                      <div>
                        <img
                          src={GetCrewPhoto ? GetCrewPhoto : logo}
                          alt="Smiley face"
                          width="100%"
                          class=""
                        ></img>
                      </div>
                    </Modal.Body>
                  </Modal>
                  {this.renderCardPendingData()}
                </div>
              </div>
            </div>
          </div>
        </div>

        {totalRecords !== 0 ? (
          <div className="custom-paginator">
            <Paginator
              first={this.state.first}
              rows={pageSize}
              totalRecords={totalRecords}
              onPageChange={(e) => this.onPaginatorChange(e)}
            ></Paginator>
          </div>
        ) : (
          <div
            className="card"
            style={{ overflow: "hidden", position: "relative" }}
          >
            <div class="container">
              <h6 className="resource-list-title no-item-card">
                !-- No Items to Display --!
              </h6>
            </div>
          </div>
        )}
      </div>
    );
  }

  onPaginatorChange(event) {
    this.setState({
      first: event.first,
    });
    const { setUpdatedState } = this.props;
    setUpdatedState(event.page + 1);
  }

  getPhotoView = (item) => {
    this.props.dispatch({ type: "getCrewPhotoSuccess", data: "" });
    this.state.Name = item.name;
    this.setState({ modalIsOpen: true });
    this.props.dispatch(getCrewPhoto(item.reportId));
  };

  renderCardPendingData = () => {
    const { arraylist, showSidePane } = this.props;
    return arraylist && arraylist.length
      ? arraylist.map((item, index) => {
        return (
          <div
            className="card"
            style={{ overflow: "hidden", position: "relative" }}
          >
            <OverlayTrigger
              placement="left-start"
              delay={{ show: 250, hide: 400 }}
              overlay={this.renderPopover(item.result)}
            >
              {item?.reading?.toLowerCase() === "refuse" ? (
                <div className="arrow-right-orange"></div> 
              ) : item?.result === null ? (
                " "
              ) : item?.result?.toLowerCase() === "true" ? (
                <div className="arrow-right-red"></div>
              ) : (
                <div className="arrow-right-green"></div>
              )}
            </OverlayTrigger>
            <div className="p-2">
              <div className="resource-list-auth-date">
                <div className="row">
                  <div
                    className={
                      !showSidePane
                        ? "col-md-2 col-sm-2 col-lg-1 col-10 col-m-auto"
                        : "col-md-2 col-sm-2 col-lg-1 col-10 col-m-auto"
                    }
                  >
                    <div className="text-center rounded-circle m-1">
                      <a onClick={() => this.getPhotoView(item)}>
                        <img
                          src={item.photo ? item.photo : logo}
                          alt="Smiley face"
                          height="85"
                          width="85"
                          class="rounded-circle"
                        ></img>
                      </a>
                    </div>
                  </div>
                  <div
                    className={
                      !showSidePane
                        ? "col-md-10 col-sm-10 col-lg-10 col-10 col-m-auto mr-4 ml-3"
                        : "col-md-10 col-sm-10 col-lg-10 col-10 col-m-auto mr-4 ml-3"
                    }
                  >
                    <div className="row">
                      {item.crewId === null ? (
                        <>
                          <div
                            className="col-sm-3 col-md-3 pb-2"
                            style={{
                              display:
                                item.crewId === null ? "block" : "none",
                            }}
                          >
                            <span>
                              <strong>Visitor</strong>
                            </span>
                          </div>

                          <div className="col-sm-3 col-md-3 col-lg-3 pb-2">
                            <span>
                              <strong>Reading : </strong>
                              <span className="italicFont ">
                                {item ? item.reading : ""}
                              </span>
                            </span>
                          </div>
                          <div className="col-sm-3 col-md-3 col-lg-3 pb-2">
                            <span>
                              <strong>Result : </strong>
                              <span className="italicFont ">
                                {item &&
                                  item?.reading?.toLowerCase() === "refuse"
                                  ? "-"
                                  : item?.result?.toLowerCase() === "true"
                                    ? "Fail"
                                    : "Pass"}
                              </span>
                            </span>
                          </div>
                          <div className="col-sm-3 col-md-3 col-lg-3 pb-2"></div>
                          <div className="col-sm-3 col-md-3 col-lg-3 pb-2">
                            <span>
                              <strong>Ship Name : </strong>
                              <span className="italicFont ">
                                {item ? item.shipName : ""}
                              </span>
                            </span>
                          </div>
                          {/* <div className="col-sm-3 col-md-3 col-lg-3 pb-2">
                          <span>
                            <strong>Temperature  : </strong>
                            <span className="italicFont ">
                            {item.temprature ? item.temprature: " - "}
                            </span>
                          </span>
                        </div> */}
                          <div className="col-sm-6 col-md-6 col-lg-6 pb-2">
                            <span>
                              <strong>Date : </strong>
                              <span className="italicFont">
                                {item
                                  ? Moment(
                                    new Date(Date.parse(item.dateTime))
                                  ).format("DD-MM-YYYY h:mm" + " " + "UTC")
                                  : ""}
                              </span>
                            </span>
                          </div>

                        </>
                      ) : (
                        <>
                          <div
                            className="col-sm-3 col-md-3 col-lg-3 pb-2"
                            style={{
                              display:
                                item.crewId === null ? "none" : "block",
                            }}
                          >
                            <span>
                              <strong>Crew ID : </strong>
                              <span className="italicFont ">
                                {item ? item.crewId : ""}
                              </span>
                            </span>
                          </div>
                          <div
                            className="col-sm-3 col-md-3 col-lg-3 pb-2"
                            style={{
                              display: item.name === null ? "none" : "block",
                            }}
                          >
                            <span>
                              <strong>Name : </strong>
                              <span className="italicFont ">
                                {item ? item.name : ""}
                              </span>
                            </span>
                          </div>
                          <div className="col-sm-3 col-md-3 col-lg-3 pb-2">
                            <span>
                              <strong>Reading : </strong>
                              <span className="italicFont ">
                                {item ? item.reading : ""}
                              </span>
                            </span>
                          </div>
                          <div className="col-sm-3 col-md-3 col-lg-3 pb-2">
                            <span>
                              <strong>Result : </strong>
                              <span className="italicFont ">
                                {item &&
                                  item?.reading?.toLowerCase() === "refuse"
                                  ? "-"
                                  : item?.result?.toLowerCase() === "true"
                                    ? "Fail"
                                    : "Pass"}
                              </span>
                            </span>
                          </div>
                          <div className="col-sm-3 col-md-3 col-lg-3 pb-2">
                            <span>
                              <strong>Ship Name : </strong>
                              <span className="italicFont ">
                                {item ? item.shipName : ""}
                              </span>
                            </span>
                          </div>

                          <div
                            className="col-sm-3 col-md-3 col-lg-3 pb-2"
                            style={{
                              display:
                                item.designation === null ? "none" : "block",
                            }}
                          >
                            <span>
                              <strong>Rank : </strong>
                              <span className="italicFont ">
                                {item ? item.designation : ""}
                              </span>
                            </span>
                          </div>
                          {/* <div className="col-sm-3 col-md-3 col-lg-3 pb-2">
                          <span>
                            <strong>Temperature  : </strong>
                            <span className="italicFont ">
                            {item.temprature ? item.temprature: " - "}
                            </span>
                          </span>
                        </div> */}
                          <div className="col-sm-3 col-md-3 col-lg-3 pb-2">
                            <span>
                              <strong>Date : </strong>
                              <span className="italicFont">
                                {item
                                  ? Moment(
                                    new Date(Date.parse(item.dateTime))
                                  ).format("DD-MM-YYYY h:mm" + " " + "UTC")
                                  : ""}
                              </span>
                            </span>
                          </div>

                        </>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        );
      })
      : null;
  };
}

function mapStateToProps(state) {
  return {
    GetCrewPhoto: state.CrewManagementReducer.GetCrewPhoto || "",
    showSidePane: state.SidePanReducer.sidePan || false,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    dispatch,
  };
}

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(MMPLCrewVisitorCard)
);
